import {Injectable} from '@angular/core';

declare var $: any;

@Injectable()
export class NotificationService {

  constructor() {
  }

  smallBox(data, cb?) {
    $.smallBox(data, cb)
  }

  bigBox(data, cb?) {
    $.bigBox(data, cb)
  }

  smartMessageBox(data, cb?) {
    $.SmartMessageBox(data, cb)
  }

  exibirNotificacaoErroGenerico() {
    this.exibirNotificacaoErro('Erro', 'Ocorreu um erro inesperado. Entre em contato com o administrador do sistema.');
  }

  exibirNotificacaoErro(titulo: string, mensagem: string) {
    this.bigBox({
      title: titulo,
      content: mensagem,
      color: '#c13636',
      icon: 'fa fa-ban swing animated',
      number: '4',
      timeout: 6000
    });
  }

  exibirNotificacaoAlerta(titulo: string, mensagem: string) {
    this.bigBox({
      title: titulo,
      content: mensagem,
      color: '#ff7f00',
      icon: 'fa fa-exclamation-triangle swing animated',
      number: '4',
      timeout: 6000
    });
  }

  exibirNotificacaoSucesso(titulo: string, mensagem: string) {
    this.bigBox({
      title: titulo,
      content: mensagem,
      color: '#739E73',
      icon: 'fa fa-check swing animated',
      number: '4',
      timeout: 6000
    });
  }


  exibirNotificacaoAviso(titulo: string, mensagem: string) {
    this.bigBox({
      title: titulo,
      content: mensagem,
      color: '#61b2f8',
      icon: 'fa fa-info-circle swing animated',
      number: '4',
      timeout: 6000
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/notification.service.ts